import React, { useState } from 'react';

const links = [
    { href: '#hero',       label: 'home' },
    { href: '#about',      label: 'about' },
    { href: '#experience', label: 'experience' },
    { href: '#projects',   label: 'projects' },
    { href: '#contact',    label: 'contact' },
    { href: '/Resume-Raghul-Saravanasundaram.pdf', label: 'resume', external: true },
];

export default function NavBar() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <nav className="fixed top-0 w-full bg-[#0d1117]/90 border-b border-[#30363d] backdrop-blur-sm z-50 font-mono">
            <div className="max-w-3xl mx-auto flex items-center py-4 px-6">
                {/* Logo */}
                <a href="#hero" className="text-[#3fb950] font-semibold text-sm mr-auto tracking-wide">
                    ~/raghul
                </a>

                {/* Desktop links */}
                <ul className="hidden md:flex items-center space-x-8">
                    {links.map(l => (
                        <li key={l.href}>
                            <a
                                href={l.href}
                                target={l.external ? '_blank' : undefined}
                                rel={l.external ? 'noopener noreferrer' : undefined}
                                className="text-sm text-[#8b949e] hover:text-[#3fb950] transition-colors duration-200"
                            >
                                <span className="text-[#30363d]">~/</span>{l.label}
                            </a>
                        </li>
                    ))}
                </ul>

                {/* Hamburger */}
                <button
                    onClick={() => setIsOpen(o => !o)}
                    className="md:hidden text-[#8b949e] hover:text-[#3fb950] transition-colors text-xl ml-6"
                    aria-label="Toggle menu"
                >
                    {isOpen ? '✕' : '☰'}
                </button>
            </div>

            {/* Mobile menu */}
            {isOpen && (
                <ul className="md:hidden flex flex-col bg-[#161b22] border-t border-[#30363d] px-6 py-5 space-y-4">
                    {links.map(l => (
                        <li key={l.href}>
                            <a
                                href={l.href}
                                target={l.external ? '_blank' : undefined}
                                rel={l.external ? 'noopener noreferrer' : undefined}
                                onClick={() => setIsOpen(false)}
                                className="flex items-center gap-2 text-sm text-[#8b949e] hover:text-[#3fb950] transition-colors"
                            >
                                <span className="text-[#3fb950]">❯</span>
                                {l.label}
                            </a>
                        </li>
                    ))}
                </ul>
            )}
        </nav>
    );
}
